import React from "react";
import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import {
  centersActions,
  instructorActions,
} from "../../../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { translationConstants } from "../../../../../constants";

const RejectModal = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const isNafes = () => {
    return props.title === translationConstants.REJECT_NAFES;
  };

  const onSubmit = (data) => {
    if (props.isRejectCenterSpot) {
      const dataToSend = {
        centerSpotId: props.modalData?.centerSpotId,
        centerEmail: props.formState?.centerUserInfo[0]?.email,
        status: 1,
        comments: data.comment,
      };
      dispatch(
        centersActions.approveCenterSpot(
          dataToSend,
          props.centerId,
          props.setAddLocationModal
        )
      );
    } else {
      const dataToSend = {
        requestType: isNafes() ? 0 : 1,
        centerId: props.centerId,
        centerEmail: props.formState?.centerUserInfo[0]?.email,
        centerStatus: isNafes() ? props.formState.centerStatus : 0,
        nafesStatus: isNafes() ? 1 : props.formState.nafesStatus,
        comments: data.comment,
        nafesDocumentStatus: 1,
      };
      dispatch(centersActions.approveCenters(dataToSend));
      dispatch(instructorActions.toggleViewModal(false));
      if (props?.setRejectNafesModal) {
        props?.setRejectNafesModal(false);
      }
    }
  };
  return (
    <Form className="approvalCertificateDiv" onSubmit={handleSubmit(onSubmit)}>
      <div className="ViewHeader">
        <p className="viewUserPara">{t(props.title)}</p>
      </div>
      <p className="horizentalLine" />

      <Form.Group className="form-group formgroupTextarea">
        <Form.Label className="Form-labels">
          {t(translationConstants.comments)}
        </Form.Label>
        <textarea
          className="commentInput"
          {...register("comment", {
            required: t(translationConstants.commentRequired),
          })}
          id="comment"
          type="text"
        />
        {errors.comment && (
          <p className="errorText">{errors.comment.message}</p>
        )}
      </Form.Group>

      <button className="rejected-button" type="submit">
        {t(translationConstants.Reject)}
      </button>
    </Form>
  );
};

export default RejectModal;
